import { render } from "./payment-banking.vue?vue&type=template&id=556ee449&scoped=true"
import script from "./payment-banking.vue?vue&type=script&lang=js"
export * from "./payment-banking.vue?vue&type=script&lang=js"

import "./payment-banking.vue?vue&type=style&index=0&id=556ee449&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556ee449"]])

export default __exports__